import dayjs from 'dayjs';
import Model from '../models/model';
import util from '../util';
import consts from '../consts';
import { dataStore } from '../Store';
import EndoIndicatorResult from '../views/endosystemcycleinfoviews/EndoIndicatorResult';

const isparametric = () => {
	const { auth } = dataStore.getState()
	const loadRelease = auth?.tags?.LoadReleaseId;
	return loadRelease === consts.LoadReleaseType.Parametric;
}
const checkIsNotParametric = () => !isparametric()
const { renderAttachmentButton } = util;

const model = new Model({
	name: 'Cycle',
	disableAdd: true,
	disableDelete: true,
	disableExport: false,
	defaultSort: 'CycleStart DESC',
	title: "Liquid Chemical Cycle",
	showGridRefreshBtn: true,
	headerFilterProps: {
		className: 'HeaderFilterForm'
	},
	columns: [
		{ field: 'CycleName', header: "CycleName", width: 200 },
		{ field: 'CycleCount', header: "CycleCount", width: 150, align:'right', headerAlign:'right'},
		{ field: 'CycleStatus', header: "SterCycleStatus", width: 200 },
		{ field: 'CycleStart', header: "CycleDateTime", width: 200, type: 'dateTime' },
		{ field: 'ErrorDescription', header: "AlarmDescription", width: 150 },
		{ field: 'Label', header: "Label", width: 150 },
		{ field: 'EndoscopeTopName', header: "Endoscope", width: 150 },
		{ field: 'InstrumentSN', header: "EndoscopeId", width: 150, valueFormatter: util.removecommas },
		{ field: 'ModelNumber', header: "EndoscopeType", width: 150, valueFormatter: util.removecommas },
		{ field: 'OperatorName', header: "OperatorName", width: 150 },
		{ field: 'UnloadOperatorName', header: "UnloadOperatorName", width: 150 },
		{ field: 'UnloadOperatorID', header: "UnloadOperatorID", width: 150 },
		{ field: 'AttachFile', header: "AttachFile", width: 150, renderCell: ({ row }) => (renderAttachmentButton(row)), filterable: false, isNotExportField: true },
		{ header: 'STSLotNumber', field: 'STSLotNumber', width: 85 },
		{ header: 'STSResult', field: 'STSResultIcon', width: 85, renderCell: ({ row }) => (<EndoIndicatorResult data={row} dataProperty={"STSResultIcon"} refreshGrid={true} />), filterable: false, isNotExportField: true },
		{ header: 'CILotNumber', field: 'LCSCILotNumber', width: 85 },
		{ header: 'CIResult', field: 'LCSCIResultIcon', width: 85, renderCell: ({ row }) => (<EndoIndicatorResult data={row} dataProperty={"LCSCIResultIcon"} refreshGrid={true} />), filterable: false, isNotExportField: true },
		{ field: 'CycleActionStatus', header: "ReviewStatus", width: 150, excludeOnGrid: checkIsNotParametric },
		{ field: 'ReviewComment', header: "Comment", width: 150, excludeOnGrid: checkIsNotParametric },
		{ field: 'ReviewDate', header: "ApprovedOn", type: 'dateTime', width: 150, isLocal: true, excludeOnGrid: checkIsNotParametric },
		{ field: 'ReviewByUser', header: "ApprovedBy", width: 150, excludeOnGrid: checkIsNotParametric },
		{
			field: 'startDate',
			header: 'Start Date',
			width: 100,
			headerFilter: true,
			standaloneHeaderFilter: true,
			type: 'date',
			format: consts.MomentFormat.MonthDateYear,
			isNotformfield: true,
			filterable: false,
			maxDate: ({ formik }) => (formik.values.endDate ? dayjs(formik.values.endDate) : undefined),
			hidden: true
		},
		{
			field: 'endDate',
			header: 'End Date',
			width: 100,
			headerFilter: true,
			standaloneHeaderFilter: true,
			type: 'date',
			format: consts.MomentFormat.MonthDateYear,
			isNotformfield: true,
			minDate: ({ formik }) => (formik.values.startDate ? dayjs(formik.values.startDate) : undefined),
			hidden: true
		}
	]
});

export const LequidChemicalTable = model;
export default model.createFormBase();
